import React, { useEffect } from 'react';
import { CheckCircle } from 'lucide-react';
import toastStyles from './Toast.module.css';

const Toast = ({ message, onClose }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 3000); // Auto close after 3 seconds

    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div className={toastStyles.toast}>
      <CheckCircle className={toastStyles.icon} />
      <span>{message}</span>
    </div>
  );
};

export default Toast; 